import Vue from "vue"
import VueRouter from "vue-router"

import Login from "../components/sessions/UserLogin.vue"
import Terms from "../components/sessions/Terms.vue"
import Policy from "../components/sessions/Policy.vue"
import {Route} from "../registry/routes.js"
import homeroute from "./pages/home.js"
import Preview from '../components/filePreview/filepreview.vue';
import FusionBrowseForBlaze from "../components/blaze/FusionBrowse.vue";
import UploadMetadataForNRAA from "../components/NRAA/uploadMetadata.vue";
import Consts from "../components.constants.js"
// import Explorer from "../components/core/Explorer.vue"
import Store from "../store/index.js";
import Utils from "../components.utils.js"

//To add any css to any routes can be done on <a> anchor tag
Vue.use(VueRouter)

const previewroute = new Route("preview", "/assets/:assetId/view", {"preview": Preview}, {componentType:"preview_component", title: 'File Preview'}, [], true, null)
// let children = [homeroute, previewroute]
// const loginroute = new Route("login", Consts.startRoute, {"login":Login}, {componentType:"login_component", title:"Login"}, children, true, null)
const loginroute = new Route("login", "/login" , {"login":Login}, {componentType:"login_component", title:"Login"}, [], true, null)
const termsroute = new Route("terms", "/terms" , {"terms":Terms}, {componentType:"terms_component", title:"Terms"}, [], true, null)
const policyroute = new Route("policy", "/policy" , {"policy":Policy}, {componentType:"policy_component", title:"Policy"}, [], true, null)

/**
 * Fusion browse from blaze
 * Below end points are intended to browse files from blaze by using those end points
 */
const logiRouteForFusionBrowseBlaze = new Route("blaze_fusion_login", "/fusion-browse/blaze/login" , {"blaze_fusion_login":Login}, {componentType:"fusion_browse_component", title:"Login"}, [], true, null)
const fusionBrowseComponentBlaze = new Route("blaze_fusion_browse", "/fusion-browse/blaze/files" , {"blaze_fusion_browse":FusionBrowseForBlaze}, {componentType:"fusion_browse_component", title:"Browse"}, [], true, null)

/**
 * Fusion browse from blaze
 *  END
 */

/**
 * Fusion browse from NRAA
 * Below end points are intended to browse files from NRAA by using those end points
 */
const uploadMetadataComponentNRAA = new Route("NRAA_upload_metadata", "/fusion-browse/NRAA/uploadMetadata" , {"NRAA_upload_metadata":UploadMetadataForNRAA}, {componentType:"fusion_browse_component", title:"Browse"}, [], true, null)
/**
 * Fusion browse from NRAA
 *  END
 */

const router = new VueRouter({
    mode: "history",
    routes:[
      {
          path:'/',
          redirect: '/explorer',
      },
      homeroute.toJSON(),
      previewroute.toJSON(),
      loginroute.toJSON(),
      termsroute.toJSON(),
      policyroute.toJSON(),

      logiRouteForFusionBrowseBlaze.toJSON(),
      fusionBrowseComponentBlaze.toJSON(),
      uploadMetadataComponentNRAA.toJSON(),
    ],
    linkActiveClass: 'active',
    scrollBehavior(_, _2, savedPosition) { //This function keeps track of scroll bar location
        if (savedPosition) {
          return savedPosition;
        }
        return { left: 0, top: 0 };  //By default scrolls to the top of the page
      }
})

router.beforeEach(async(to, from, next) => {
    let resolvedRoute = router.resolve({name:to.name});
    try{
       if(to.name && !resolvedRoute.resolved.matched.length) {
          const pluginRouteMap = Store.getters['registry/getPluginRouterRoutesForLoading']; 
          if(pluginRouteMap && pluginRouteMap[to.name] && typeof pluginRouteMap[to.name].register == 'function'){
             await new Promise((resolve, reject) => {
                 // max wait for 3000 milliseconds to load route
                const timer = setTimeout(() => reject(new Error(`[router] plugin registration timed out for route: ${to.name}`)), 3000);
                pluginRouteMap[to.name].register(null,() => {
                    clearTimeout(timer);
                    resolve();
                    setTimeout(()=>{
                        next({ ...to, replace: true });
                    },0);
                });
             });
          }
        }
    }catch(e){console.log(e)}
    try{
      if (to.name && !resolvedRoute.resolved.matched.length) { // if route does not exists
        let res = router.app.$children[0].loadExternalOnDemandPlugin(to);
        console.log(`No Route.... res :::: `, to , res);
            if(res){
    /*             setTimeout(() => { // setTimeout is required for loading external plugin
                    next({
                        name: to.name,
                        replace: false,
                        query: to.query,
                        params: to.params
                    });
                }, 1000); */
                return;
            } 
        }
    }catch(e){console.log(e)}
    
    if(to && to.matched.length === 0){
        // eslint-disable-next-line no-useless-escape
        let reg = new RegExp("^\/explorer\/projects(?:\/((?:[^\/]+?)))?(?:\/((?:[^\/]+?)))?(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$");
        if(reg.test(window.location.pathname)){
            try{
                let match = String(window.location.pathname).match(reg);
                if(match && match.length){
                let projectId = match[1];
                let projectType = match[2];
                let taskId = match[3];
                console.log(`projectId`,projectId,'projectType',projectType,'taskId',taskId);
                return next({
                    name: "tasks-window",
                    params:{
                        taskId: taskId,
                        tabType:"de"
                    },
                    query:{
                        editMode:true
                    },
                    replace: true,
                });
                }
            }catch(e){console.log('Old Tasks routing scheme',e)}
         }
        
         // eslint-disable-next-line no-useless-escape
         let reg2 = new RegExp("^\/explorer\/projects\/([^/]+)\/catalogs\/([^/]+)\/metadata\/([^/]+)\/tag$");
            if(reg2.test(window.location.pathname)){
                try{
                    let match = String(window.location.pathname).match(reg2);
                    if(match && match.length){
                        console.log("matchmatchmatch",match)
                    let projectId = match[1];
                    let projectType = match[2];
                    let taskId = match[3];
                    console.log(`projectId`,projectId,'projectType',projectType,'taskId',taskId);
                    return next({
                        name: "tasks-window",
                        params:{
                            taskId: taskId,
                            tabType:"de"
                        },
                        query:{
                            editMode:true
                        },
                        replace: true,
                    });
                    }
                }catch(e){console.log('Old Tasks routing scheme',e)}
            }
    }


    try {
        // This goes through the matched routes from last to first, finding the closest route with a title.
        // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
        // `/nested`'s will be chosen.

        const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  
        // Find the nearest route element with meta tags.
        const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
    
        const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
    
        // If a route with a title was found, set the document (page) title to that value.
        if(nearestWithTitle && nearestWithTitle.meta && nearestWithTitle.meta.title) {
            document.title = `${nearestWithTitle.meta.title} | ${Consts.defaultTitle}`;
        } else if(previousNearestWithMeta && previousNearestWithMeta.meta && previousNearestWithMeta.meta.title) {
            document.title = `${previousNearestWithMeta.meta.title} | ${Consts.defaultTitle}`;
        }else{
            document.title = Consts.defaultTitle
        }
    
        // Remove any stale meta tags from the document using the key attribute we set below.
        Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
    
        // Skip rendering meta tags if there are none.
        if(!nearestWithMeta) return next();
    
        // Turn the meta tag definitions into actual elements in the head.
        nearestWithMeta.meta.metaTags.map(tagDef => {
        const tag = document.createElement('meta');
    
        Object.keys(tagDef).forEach(key => {
            tag.setAttribute(key, tagDef[key]);
        });
    
        // We use this to track which meta tags we create so we don't interfere with other ones.
        tag.setAttribute('data-vue-router-controlled', '');
    
        return tag;
        })
        // Add the meta tags to the document head.
        .forEach(tag => document.head.appendChild(tag));   
    } catch (error) {
        console.warn(`[beforeEachRoute][Exception while updating document title setting default title]`)
        document.title = Consts.defaultTitle
    }
    try{
        if(Store.getters['users/getLoggedInUser'] != null && to.name == 'login'){
            return false;
        }
    }catch(e){console.log(e)}

    try{
        if(Utils.getCookieValue('session_id') && to.name == 'login'){
            next({
               name:'explorer',
               replace: true
            });
        }
    }catch(e){console.log(e)}

    console.log(`[beforeEachbeforeEach beforeEach] route name`,to,from);

    next();
  })

export default router;